import axiosInstance from '../../utils/axiosInstance';
import { GetUKDirectDebitResponse } from './types';

export const getDirectDebit = async () => {
  const response = await axiosInstance.get<GetUKDirectDebitResponse>('/uk/direct-debit');
  return response.data;
};
